module.exports = __webpack_public_path__ + "static/venueSpaces-f4f94c4780fc7b83305233bc75fef411.jpg";